import type { VisualElement } from "@judo/model-api";
import Grid from "@mui/material/Grid";
import { DIVIDER_HEIGHT } from "./renderer-constants";

export interface SpacerRendererProps {
	element: VisualElement;
}

/**
 * Spacer renderer using an empty Grid container with fixed height.
 * Matches the template pattern: Grid container with DIVIDER_HEIGHT, no children.
 */
export function SpacerRenderer({ element }: SpacerRendererProps) {
	return <Grid container sx={{ height: DIVIDER_HEIGHT }} data-testid={`spacer::${element["xmi:id"]}`} />;
}
